export const PUBLIC = 'public';
export const PUBLIC_NAME = '官方素材';
export const PIC_PRIVATE = 'pic_private';
export const PIC_NAME = '我的';

export const M_APP_NAME = '梦予';

export const APP_NAME = M_APP_NAME;
